import dayjs from "dayjs";
import {
  PERMISSION_LEVEL_BLOCKED,
  PERMISSION_LEVEL_TIME_LIMITED,
  PERMISSION_TIME_SAME_DAY,
} from "./constants/permission.js";

export default function isDayLimited(date, permission) {
  if (permission?.level === PERMISSION_LEVEL_BLOCKED) {
    return true;
  } else if (permission?.level === PERMISSION_LEVEL_TIME_LIMITED) {
    const today = dayjs();

    if (permission.timeWindow === PERMISSION_TIME_SAME_DAY) {
      return today.format("YYYY-MM-DD") !== date;
    } else {
      return date < today.subtract(permission.days, "days").format("YYYY-MM-DD");
    }
  } else {
    return false;
  }
}
